export default "__VITE_PUBLIC_ASSET__86bd4dcc__"